import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';

const AdminLayout = lazy(() => import('./components/AdminLayout'));
const HomePage = lazy(() => import('./pages/HomePage'));
const CategoriesPage = lazy(() => import('./pages/CategoriesPage'));
const CategoryPage = lazy(() => import('./pages/CategoryPage'));
const TopicPage = lazy(() => import('./pages/TopicPage'));
const SearchPage = lazy(() => import('./pages/SearchPage'));
const NewTopicPage = lazy(() => import('./pages/NewTopicPage'));
const LoginPage = lazy(() => import('./pages/LoginPage'));
const RegisterPage = lazy(() => import('./pages/RegisterPage'));
const ForgotPasswordPage = lazy(() => import('./pages/ForgotPasswordPage'));
const ResetPasswordPage = lazy(() => import('./pages/ResetPasswordPage'));
const VerifyEmailPage = lazy(() => import('./pages/VerifyEmailPage'));
const AdminDashboard = lazy(() => import('./pages/admin/AdminDashboard'));
const AdminUsers = lazy(() => import('./pages/admin/AdminUsers'));
const AdminCategories = lazy(() => import('./pages/admin/AdminCategories'));
const AdminTopics = lazy(() => import('./pages/admin/AdminTopics'));
const AdminSettings = lazy(() => import('./pages/admin/AdminSettings'));
const AdminAuditLog = lazy(() => import('./pages/admin/AdminAuditLog'));
const AdminTags = lazy(() => import('./pages/admin/AdminTags'));
const AdminModeration = lazy(() => import('./pages/admin/AdminModeration'));
const AdminUserPosts = lazy(() => import('./pages/admin/AdminUserPosts'));
const ProfilePage = lazy(() => import('./pages/ProfilePage'));
const UserProfilePage = lazy(() => import('./pages/UserProfilePage'));

export default function App() {
  return (
    <Suspense fallback={<div className="flex items-center justify-center min-h-[60vh]"><div className="w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin" /></div>}>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/categories" element={<CategoriesPage />} />
          <Route path="/c/:slug" element={<CategoryPage />} />
          <Route path="/t/:slug" element={<TopicPage />} />
          <Route path="/topic/*" element={<TopicPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/new-topic" element={<NewTopicPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/u/:userID" element={<UserProfilePage />} />
        </Route>
        <Route element={<AdminLayout />}>
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/admin/users/:userID" element={<AdminUserPosts />} />
          <Route path="/admin/categories" element={<AdminCategories />} />
          <Route path="/admin/tags" element={<AdminTags />} />
          <Route path="/admin/topics" element={<AdminTopics />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="/admin/audit-log" element={<AdminAuditLog />} />
          <Route path="/admin/moderation" element={<AdminModeration />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
